import type { ModelData } from '../../types'

export const nemoNarozne: { [key: string]: ModelData } = {
  'nemo-2b': {
    id: 'nemo-2b',
    name: 'NEMO 2B',
    power: '15 kW',
    type: 'wodny',
    glassType: 'narozna' as const,
    image: 'images/nemo-2b.jpg',
    emailSubject: 'Zapytanie - NEMO 2B',
    description: 'Wkład wodny narożny 15 kW',
    specialNote: 'Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.',
    basePrices: {
      standard: {
        single: 11770,
        'single-connected': 12740,
        double: 13910,
        'double-connected': 14880
      },
      lift: {
        single: 15410,
        'single-connected': 16380,
        double: 17550,
        'double-connected': 18520
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 600,
          'flush-30': 690,
          'recessed-15': 790,
          'recessed-30': 900,
          'recessed-15-45': 990
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 730,
          'recessed-lift-30': 850,
          'recessed-lift-5': 1600
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 0
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-g': 1440,
        'rt-08-g-wb': 1570,
        'rt-08-g-x-wb': 1890,
        'rt-08-g-duo-integra': 1800,
        'rt-08-g-wb-duo-integra': 1850,
        'rt-08-g-x-duo-integra': 2400,
        'rt-08-g-x-wb-duo-integra': 2450
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Szyba dzielona x1', 
        'single-connected': 'Szyba gięta x1',
        'double': 'Szyba dzielona x2',
        'double-connected': 'Szyba gięta x2'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'rt-08-g': 'RT-08G TITANIUM',
        'rt-08-g-wb': 'RT-08G WHITE / BLACK',
        'rt-08-g-x-wb': 'RT-08GX WHITE / BLACK',
        'rt-08-g-duo-integra': 'RT-08 G DUO INTEGRA TITANIUM',
        'rt-08-g-wb-duo-integra': 'RT-08G DUO INTEGRA WHITE / BLACK',
        'rt-08-g-x-duo-integra': 'RT-08GX DUO INTEGRA TITANIUM',
        'rt-08-g-x-wb-duo-integra': 'RT-08GX DUO INTEGRA WHITE / BLACK',
        'czujnik-drzwiczek': 'Czujnik drzwiczek'
      }
    },
    specs: {
      power: '16 kW',
      efficiency: '89,9%',
      energyClass: 'A',
      waterHeaterPower: '3,4-10,0 kW',
      waterCapacity: '40 dm³',
      glassSize: '681+336 x 471 mm',
      insertSize: '711 x 1400-1555 x 461 mm',
      fireplaceSize: '445 x 500 x 254 mm',
      maxLogLength: '500 mm',
      weight: '227 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - NEMO 2B',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego NEMO 2B w konfiguracji:\n\nModel: NEMO 2B\nMoc: 15 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.\n\nPozdrawiam'
    },
    additionalOptions: {
      thermalProtection: {
        price: 420
      }
    }
  },

  'nemo-2b-xl': {

    id: 'nemo-2b-xl',

    name: 'NEMO 2B XL',
    power: '15 kW',
    type: 'wodny',
    glassType: 'narozna' as const,
    image: 'images/nemo-2b-xl.jpg',
    emailSubject: 'Zapytanie - NEMO 2B XL',
    description: 'Wkład wodny narożny 15 kW',
    specialNote: 'Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.',
    basePrices: {
      standard: {
        single: 11990
      },
      lift: {
        single: 15630
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 650,
          'flush-30': 740,
          'recessed-15': 850,
          'recessed-30': 970,
          'recessed-15-45': 1050
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 780,
          'recessed-lift-30': 890,
          'recessed-lift-5': 1680
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 0
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-g': 1440,
        'rt-08-g-wb': 1570,
        'rt-08-g-x-wb': 1890,
        'rt-08-g-duo-integra': 1800,
        'rt-08-g-wb-duo-integra': 1850,
        'rt-08-g-x-duo-integra': 2400,
        'rt-08-g-x-wb-duo-integra': 2450
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Szyba dzielona x1'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'rt-08-g': 'RT-08G TITANIUM',
        'rt-08-g-wb': 'RT-08G WHITE / BLACK',
        'rt-08-g-x-wb': 'RT-08GX WHITE / BLACK',
        'rt-08-g-duo-integra': 'RT-08 G DUO INTEGRA TITANIUM',
        'rt-08-g-wb-duo-integra': 'RT-08G DUO INTEGRA WHITE / BLACK',
        'rt-08-g-x-duo-integra': 'RT-08GX DUO INTEGRA TITANIUM',
        'rt-08-g-x-wb-duo-integra': 'RT-08GX DUO INTEGRA WHITE / BLACK',
        'czujnik-drzwiczek': 'Czujnik drzwiczek'
      }
    },
    specs: {
      power: '16,5 kW',
      efficiency: '89,9%',
      energyClass: 'A',
      waterHeaterPower: '3,4-10,0 kW',
      waterCapacity: '40 dm³',
      glassSize: '681+336 x 514 mm',
      insertSize: '711 x 1443-1598 x 461 mm',
      fireplaceSize: '488 x 500 x 254 mm',
      maxLogLength: '500 mm',
      weight: '227 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - NEMO 2B XL',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego NEMO 2B XL w konfiguracji:\n\nModel: NEMO 2B XL\nMoc: 15 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.\n\nPozdrawiam'
    },
    additionalOptions: {
      thermalProtection: {
        price: 420
      }
    }
  },

  'nemo-4b-slim': {

    id: 'nemo-4b-slim',

    name: 'NEMO 4B SLIM',
    power: '20 kW',
    type: 'wodny',
    glassType: 'narozna' as const,
    image: 'images/nemo-4b-slim.jpg',
    emailSubject: 'Zapytanie - NEMO 4B SLIM',
    description: 'Wkład wodny narożny 20 kW',
    specialNote: 'Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.',
    basePrices: {
      standard: {
        single: 13590,
        'single-connected': 14660,
        double: 16380,
        'double-connected': 17450
      },
      lift: {
        single: 17230,
        'single-connected': 18300,
        double: 20010,
        'double-connected': 21080
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 680,
          'flush-30': 780,
          'recessed-15': 870,
          'recessed-30': 1000,
          'recessed-15-45': 1100
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 820,
          'recessed-lift-30': 950,
          'recessed-lift-5': 1780
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 0
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-g': 1440,
        'rt-08-g-wb': 1570,
        'rt-08-g-x-wb': 1890,
        'rt-08-g-duo-integra': 1800,
        'rt-08-g-wb-duo-integra': 1850,
        'rt-08-g-x-duo-integra': 2400,
        'rt-08-g-x-wb-duo-integra': 2450
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Szyba dzielona x1', 
        'single-connected': 'Szyba gięta x1',
        'double': 'Szyba dzielona x2',
        'double-connected': 'Szyba gięta x2'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'rt-08-g': 'RT-08G TITANIUM',
        'rt-08-g-wb': 'RT-08G WHITE / BLACK',
        'rt-08-g-x-wb': 'RT-08GX WHITE / BLACK',
        'rt-08-g-duo-integra': 'RT-08 G DUO INTEGRA TITANIUM',
        'rt-08-g-wb-duo-integra': 'RT-08G DUO INTEGRA WHITE / BLACK',
        'rt-08-g-x-duo-integra': 'RT-08GX DUO INTEGRA TITANIUM',
        'rt-08-g-x-wb-duo-integra': 'RT-08GX DUO INTEGRA WHITE / BLACK',
        'czujnik-drzwiczek': 'Czujnik drzwiczek'
      }
    },
    specs: {
      power: '19 kW',
      efficiency: '89,0%',
      energyClass: 'A',
      waterHeaterPower: '6,0-12,0 kW',
      waterCapacity: '49 dm³',
      glassSize: '762+420 x 471 mm',
      insertSize: '813 x 1473-1628 x 489 mm',
      fireplaceSize: '438 x 605 x 285 mm',
      maxLogLength: '580 mm',
      weight: '271 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - NEMO 4B SLIM',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego NEMO 4B SLIM w konfiguracji:\n\nModel: NEMO 4B SLIM\nMoc: 20 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.\n\nPozdrawiam'
    },
    additionalOptions: {
      thermalProtection: {
        price: 420
      }
    }
  },

  'nemo-4b': {

    id: 'nemo-4b',

    name: 'NEMO 4B',
    power: '20 kW',
    type: 'wodny',
    glassType: 'narozna' as const,
    image: 'images/nemo-4b.jpg',
    emailSubject: 'Zapytanie - NEMO 4B',
    description: 'Wkład wodny narożny 20 kW',
    specialNote: 'Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.',
    basePrices: {
      standard: {
        single: 13910,
        'single-connected': 14980,
        double: 16700,
        'double-connected': 17770
      },
      lift: {
        single: 17550,
        'single-connected': 18620,
        double: 20330,
        'double-connected': 21400
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 680,
          'flush-30': 780,
          'recessed-15': 870,
          'recessed-30': 1000,
          'recessed-15-45': 1100
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 820,
          'recessed-lift-30': 950,
          'recessed-lift-5': 1780
        }
      },
      fusion: {
        basic: 1470,
        modules: 1710
      },
      akuPlus: {
        'aku-plus': 0
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-g': 1440,
        'rt-08-g-wb': 1570,
        'rt-08-g-x-wb': 1890,
        'rt-08-g-duo-integra': 1800,
        'rt-08-g-wb-duo-integra': 1850,
        'rt-08-g-x-duo-integra': 2400,
        'rt-08-g-x-wb-duo-integra': 2450
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Szyba dzielona x1', 
        'single-connected': 'Szyba gięta x1',
        'double': 'Szyba dzielona x2',
        'double-connected': 'Szyba gięta x2'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'rt-08-g': 'RT-08G TITANIUM',
        'rt-08-g-wb': 'RT-08G WHITE / BLACK',
        'rt-08-g-x-wb': 'RT-08GX WHITE / BLACK',
        'rt-08-g-duo-integra': 'RT-08 G DUO INTEGRA TITANIUM',
        'rt-08-g-wb-duo-integra': 'RT-08G DUO INTEGRA WHITE / BLACK',
        'rt-08-g-x-duo-integra': 'RT-08GX DUO INTEGRA TITANIUM',
        'rt-08-g-x-wb-duo-integra': 'RT-08GX DUO INTEGRA WHITE / BLACK',
        'czujnik-drzwiczek': 'Czujnik drzwiczek'
      }
    },
    specs: {
      power: '22 kW',
      efficiency: '89,0%',
      energyClass: 'A',
      waterHeaterPower: '7,5-14,0 kW',
      waterCapacity: '49 dm³',
      glassSize: '762+420 x 471 mm',
      insertSize: '797 x 1478-1633 x 574 mm',
      fireplaceSize: '438 x 580 x 370 mm',
      maxLogLength: '580 mm',
      weight: '305 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - NEMO 4B',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego NEMO 4B w konfiguracji:\n\nModel: NEMO 4B\nMoc: 20 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.\n\nPozdrawiam'
    },
    additionalOptions: {
      thermalProtection: {
        price: 420
      }
    }
  },

  'nemo-8b': {

    id: 'nemo-8b',

    name: 'NEMO 8B',
    power: '12 kW',
    type: 'wodny',
    glassType: 'narozna' as const,
    image: 'images/nemo-8b.jpg',
    emailSubject: 'Zapytanie - NEMO 8B',
    description: 'Wkład wodny narożny 12 kW',
    specialNote: 'Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.',
    basePrices: {
      standard: {
        single: 10600
      },
      lift: {
        single: 14240
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 590,
          'flush-30': 680,
          'recessed-15': 780,
          'recessed-30': 890,
          'recessed-15-45': 970
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 710,
          'recessed-lift-30': 820,
          'recessed-lift-5': 1550
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 0
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-g': 1440,
        'rt-08-g-wb': 1570,
        'rt-08-g-x-wb': 1890,
        'rt-08-g-duo-integra': 1800,
        'rt-08-g-wb-duo-integra': 1850,
        'rt-08-g-x-duo-integra': 2400,
        'rt-08-g-x-wb-duo-integra': 2450
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Szyba dzielona x1'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'rt-08-g': 'RT-08G TITANIUM',
        'rt-08-g-wb': 'RT-08G WHITE / BLACK',
        'rt-08-g-x-wb': 'RT-08GX WHITE / BLACK',
        'rt-08-g-duo-integra': 'RT-08 G DUO INTEGRA TITANIUM',
        'rt-08-g-wb-duo-integra': 'RT-08G DUO INTEGRA WHITE / BLACK',
        'rt-08-g-x-duo-integra': 'RT-08GX DUO INTEGRA TITANIUM',
        'rt-08-g-x-wb-duo-integra': 'RT-08GX DUO INTEGRA WHITE / BLACK',
        'czujnik-drzwiczek': 'Czujnik drzwiczek'
      }
    },
    specs: {
      power: '11 kW',
      efficiency: '89,0%',
      energyClass: 'A',
      waterHeaterPower: '3,8-8,0 kW',
      waterCapacity: '20 dm³',
      glassSize: '450+450 x 510 mm',
      insertSize: '499 x 1269-1405 x 475 mm',
      fireplaceSize: '495 x 312 x 312 mm',
      maxLogLength: '310 mm',
      weight: '164 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - NEMO 8B',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego NEMO 8B w konfiguracji:\n\nModel: NEMO 8B\nMoc: 12 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Wkłady Nemo wyposażone są w wężownicę schładzającą (w cenie). Istnieje możliwość doposażenia wkładu w zabezpieczenie termiczne chłodnicy w cenie 420 zł netto.\n\nPozdrawiam'
    },
    additionalOptions: {
      thermalProtection: {
        price: 420
      }
    }
  }
}
